<template>
  <th
    class="govuk-table__header fds-sortable-table__header"
    :class="{'fds-sortable-table__header--sticky': topHeader}"
    :aria-sort="ariaSort"
  >
    <button
      v-if="sortable"
      class="fds-sortable-table__header__sort-button"

      @click="sortTable"
    >
      <slot />
      <icon-arrow-up
        v-if="isSortedColumn && tableStore.sortDirection === -1"
        class="fds-sortable-table__header--icon"
        :stroke="stroke"
        size="24"
      />
      <icon-arrow-down
        v-else-if="isSortedColumn && tableStore.sortDirection === 1"
        class="fds-sortable-table__header--icon"
        :stroke="stroke"
        size="24"
      />
      <icon-arrows-sort
        v-else
        class="fds-sortable-table__header--icon"
        :stroke="stroke"
        size="24"
      />
    </button>
    <template v-else>
      <slot />
    </template>
  </th>
</template>

<script setup>
// eslint-disable-next-line import/no-extraneous-dependencies
import { computed } from "vue";
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconArrowDown, IconArrowUp, IconArrowsSort } from "@tabler/icons-vue";
import { useTableStore } from "../tableStore";

const stroke = 2;

const {
  /** @type {boolean} */
  sortable,

  /** @type {boolean} */
  topHeader,

  /** @type {number} */
  index,

  /** @type {string} */
  accessibleColumnName,
} = defineProps(["sortable", "topHeader", "index", "accessibleColumnName"]);

const tableStore = useTableStore();

const isSortedColumn = computed(() => tableStore.sortedIndex === index);

const ariaSort = computed(() => {
  if (!isSortedColumn.value) {
    return undefined;
  }

  switch (tableStore.sortDirection) {
    case 1:
      return "ascending";
    case -1:
      return "descending";
    default:
      return undefined;
  }
});

const sortTable = () => {
  if (sortable === false) {
    return;
  }

  tableStore.sortTable(index);
};
</script>